import * as t from "io-ts"

export const FleetEntryUploadRowStructure = {
  "Vehicle Registration Number": t.union([t.string, t.undefined]),
  "Vehicle Make": t.union([t.string, t.undefined]),
  "Vehicle Model": t.union([t.string, t.undefined]),
  "Vehicle On Cover Date": t.union([t.string, t.undefined]),
  "Vehicle Off Cover Date": t.union([t.string, t.undefined]),
}
const FleetEntryUploadRowType = t.type(FleetEntryUploadRowStructure)
export type FleetEntryUploadRow = t.TypeOf<typeof FleetEntryUploadRowType>

export type ValidationErrorRecord = {
  reason: string
  record: Partial<FleetEntryUploadRow>
}

export type AddFleetEntryFormError = {
  registrationNumber?: string
  onCoverDate?: string
  offCoverDate?: string
}
